<template>
  <section>
    <div class="list">
      <div class="tr border-bottom">
        <div class="left">
          <div class="empty"></div>
          <div class="class-name">Overview</div>
        </div>
        <div class="right">
          <div
            class="export pointer"
            @click="handleExport">
            <font-awesome-icon
              icon="download"
              class="icon"></font-awesome-icon>
            Export
          </div>
        </div>
      </div>
      <div class="tr">
        <div class="left">
          <div class="empty"></div>
          <div class="class-name">All</div>
        </div>
        <div class="right">
          <div
            class="export pointer"
            @click="handleImport(0)">
            <font-awesome-icon
              icon="upload"
              class="icon"></font-awesome-icon>
            Import
          </div>
        </div>
      </div>
      <div
        v-for="(item, i) in classList"
        :key="i"
        class="tr">
        <div class="left">
          <div class="icon">
            <font-awesome-icon
              v-if="item.id < 50"
              :icon="getOptionName('iconOptions', item.id)" />
            <font-awesome-icon
              v-else
              icon="cube" />
          </div>
          <div class="class-name">{{item.name}}</div>
        </div>
        <div class="right">
          <div
            class="export pointer"
            @click="handleImport(item.id)">
            <font-awesome-icon
              icon="upload"
              class="icon"></font-awesome-icon>
            Import
          </div>
          <!--          <div class="export pointer">-->
          <!--            <font-awesome-icon-->
          <!--              icon="download"-->
          <!--              class="icon"></font-awesome-icon>-->
          <!--            Export-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <import-block-list
      v-model="showImportBlock"
      :class-id="class_id"></import-block-list>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import importBlockList from '@/views/administration/components/dialog/importBlockList'
import {exportBlockList} from '@api/account'
import {downloadFile} from '@/utils/download'
export default {
  name: 'BlockList',
  components:{
    importBlockList
  },
  mixins: [MixinOptions],
  data () {
    return {
      showImportBlock:false,
      class_id:0
    }
  },
  computed:{
    classList(){
      let list = this.globalOptions.class_data.filter(item => item.id != 90)
      return list.filter(item => item.id < 50 || item.id > 80) || []
    }
  },
  methods: {
    handleImport(id){
      this.class_id = id
      this.showImportBlock = true
    },
    handleExport(){
      this.network().exportBlockList()
    },
    network(){
      return {
        exportBlockList: async (params) => {
          const res = await exportBlockList()
          downloadFile(res)
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.list{
  width: 690px;
  margin: auto;
  border: 1px solid #D1D5DA;
  border-radius: 6px;
  .border-bottom{
    border-bottom: 1px solid #D1D5DA;
    margin-bottom: 10px;
  }
  .tr{
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    background: #FFFFFF;
    .left, .right{
      display: flex;
      align-items: center;
    }
    .icon{
      margin-right: 8px;
    }
    .left{
      .icon{
        background: #E1E4E8;
        border-radius: 5px;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #e1e4e8;
        width: 22px;
        height: 22px;
        box-sizing: border-box;
        color: #6A737D;
      }
      .class-name{
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #24292E;
      }
      .empty{
        width: 22px;
        height: 22px;
        margin-right: 8px;
      }
    }
    .right{
      .icon{
        font-weight: 900;
        font-size: 14px;
        width: 14px;
        height: 16px;
        color: #0366D6;
      }
      .import{
        margin-right: 15px;
      }
      .import, .export{
        font-weight: 600;
        font-size: 14px;
        color: #0366D6;
      }
    }
    & + .tr{
      border-top: 1px solid #D1D5DA;
    }
    &:first-child{
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    &:last-child{
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
}
</style>
